<template>
  <div>
    <div class="account-address-form-wrapper">
      <VForm
        :name="name"
        :fields="formData.fields"
        :disabled="!isValid"
        :initialValues="initialValues"
      ></VForm>
    </div>

    <div class="org-general-buttons-wrapper" v-if="_isFormTouched">
      <VButton
        size="regular"
        label="Reset"
        extraClass="org-settings-general-cancel"
        @click="_cancel"
        inverted
      >
      </VButton>

      <VButton
        size="regular"
        label="Save"
        @click="_saveSettings"
        :disabled="!isValid || isLoading"
      >
      </VButton>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapGetters, mapActions } from "vuex";

// components
import VForm from "@/components/VForm";
import VButton from "@/components/VButton";

// mixins
import withForm from "@/mixins/withForm";
import withToasted from "@/mixins/withToasted";

import { required, maxLength } from "@/utils/validations";
import { accountAddressFormFields, apiToFormFieldNamesMap } from "@/constants/forms";
import { convertDataToApi } from "@/utils/util";

export default Vue.component("AccountAddressForm", {
  props: {
    initialValues: VueTypes.any
  },

  components: {
    VForm,
    VButton
  },

  mixins: [withForm, withToasted],

  data() {
    return {
      collectDataCheckbox: false,
      name: "accountAddressForm",
      formData: {
        fields: [

          ...accountAddressFormFields.map(item => {
            item.layout = "full";
            return item;
          })
        ]
      }
    };
  },

  methods: {
    _cancel() {
      this._initializeForm();
      this.clearFormErrors();
      this.setFormTouchedValue();
    },

    _saveSettings() {
      this.validateForm();

      const { company } = this.formValues;

      if (this.isValid) {
        this.updateAccount({
          values: {
            company,
            address: convertDataToApi("addressOld", this.formValues)
          },
          cb: () => {
            this.updateValues({ formName: this.name, fields: this.formValues });
            this.setFormTouchedValue();
            this.toast("Account info has been updated!", "success", {
              icon: "check "
            });
          },
          onError: message =>
            this.toast("Something went wrong, try again later.", "error")
        });
      }
    },

    _initializeForm() {
      const addressMapping = apiToFormFieldNamesMap("address");
      const obj = {};

      for (let key of Object.keys(addressMapping)) {
        obj[addressMapping[key]] = this.getAccount[key];
      }

      this.initializeForm({
        formName: this.name,
        fields: obj
      });
    },

    ...mapActions("account", ["updateAccount"])
  },

  computed: {
    _isFormTouched() {
      return this.isFormTouched();
    },

    ...mapGetters("account", ["getAccount", "isLoading"])
  },

  mounted() {
    this._initializeForm();
  }
});
</script>

<style lang="scss" scoped>
$max-width: 560px;

.org-general-buttons-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  max-width: $max-width;
}

/deep/ form {
  flex-direction: column;
}

/deep/ .input-container,
/deep/ .v-select {
  max-width: $max-width;
  margin-bottom: 42px;

  &:last-child {
    margin-bottom: 0;
  }
}

/deep/ button.inverted.org-settings-general-cancel {
  width: 70px;
  max-width: 70px;
  min-width: auto;
  border: none;
  margin-right: 30px;
}

.account-address-form-wrapper {
  margin-bottom: 52px;
}
</style>
